function initMenu(){
    for(key in slides){
        if (slides[key].type === "menu") {
          if (slides[key]["menu"]) {
            // set default menu class if one is not present
            if (!slides[key]["menu"]["menuClass"]) {
              slides[key]["menu"]["menuClass"] = "si-menu__js";
            }
            // set menu default to nonlinear if linear slide key is not present/true
            if (!slides[key]["menu"]["linear"]) {
              slides[key]["menu"]["linear"] = false; 
            }
            // set menu default menu navigation if not present.  Will match buttons to subsequent slides after the menu 
            if (!slides[key]["menu"]["navigation"]) {
              var number = slides[key]["slideNumber"];
              var buttons = $("." + slides[key]["menu"]["menuClass"]);
              var length = buttons.length;
              var defaultNav = [];
              for (var i = 1; i <= length; i++) {
                defaultNav.push(number + i);
              }
              slides[key]["menu"]["navigation"] = defaultNav;
            }
            // set default completion requirements for each button if not given.  Will match buttons to subsequent slides after the menu
            if(!slides[key]["menu"]["completionIDs"]){
              var number = slides[key]["slideNumber"];
              var buttons = $("." + slides[key]["menu"]["menuClass"]);
              var length = buttons.length;
              var completionIDs = [];
              for (var i = 1; i <= length; i++) {
                  for (id in slides) {
                    if (slides[id]["slideNumber"] == (number + i).toString()) {
                      completionIDs.push(id)
                    }
                  }
              }
              slides[key]["menu"]["completionIDs"] = completionIDs;
            }
          } else {
            // set all menu defaults if the 'menu' key is entirely absent
            slides[key]["menu"] = {};
            slides[key]["menu"]["menuClass"] = "si-menu__js";
            slides[key]["menu"]["linear"] = false;
            slides[key]["menu"]["completionIDs"] = completionIDs;
            var buttons = $("." + slides[key]["menu"]["menuClass"]);
            var number = slides[key]["slideNumber"];
            var length = buttons.length;
            var defaultNav = [];
            var completionIDs = [];
            for (var i = 1; i <= length; i++) {
              defaultNav.push(number + i);
              for (id in slides) {
                if (slides[id]["slideNumber"] == (number + i).toString()) {
                  completionIDs.push(id);
                }
              }
            }
            slides[key]["menu"]["navigation"] = defaultNav;
            slides[key]["menu"]["completionIDs"] = completionIDs;
          }
          // attach click event to the buttons using navigation array
          if (slides[key]["menu"]["navigation"].length) {
            var buttons = $("." + slides[key]["menu"]["menuClass"]);
            buttons.each(function(idx, button) {
              var slide = slides[key];
              $(button).on("click.nav", function() {
                jumpToId(slide["menu"]["navigation"][idx]);
              });
            });
          }
          // lock buttons if linear and unlock the first one
          if (slides[key]["menu"]["linear"]) {
            var buttons = $("." + slides[key]["menu"]["menuClass"]);
            lock(buttons);
            unlock($(buttons[0]));
          }


        } 
    }
}

function menuFunctions(){
    var menuButtons = $("." + slides[globalVar.curSlide]["menu"]["menuClass"]);
    var linear = slides[globalVar.curSlide]["menu"]["linear"];
    var completionIDs = slides[globalVar.curSlide]["menu"]["completionIDs"];
    var allComplete = true;
    if(completionIDs.length){
        completionIDs.forEach(function(id,idx){
            if(slideCompletion[id]){
                $(menuButtons[idx]).addClass('completed')
                if(linear && menuButtons[idx + 1]){
                    unlock($(menuButtons[idx + 1]))
                }
            }else{
                allComplete = false;
            }
        })
    }

    if(allComplete){
        slides[globalVar.curSlide]["menu"]["allComplete"] = true;
    }else{
        slides[globalVar.curSlide]["menu"]["allComplete"] = false;
    }
}